import { uiSize } from '@utils'

interface Props {
  color?: string
}

function ArrowUpIcon({ color = 'currentColor' }: Props) {
  return (
    <svg
      width={uiSize(14)}
      height={uiSize(14)}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke={color}
      strokeWidth='2.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M12 20V6M6 12l6-6 6 6' />
    </svg>
  )
}

export default ArrowUpIcon
